<template>
  <div id="app" class="fixed-sn pl-0">
    <div class="flexible-content" >
      <!--Navbar-->
      <room-nav />
      <!--/Navbar-->

      <!--MainContent-->
      <main class="pl-0">
        <div>
          <slot />
        </div>
      </main>
      <!--/MainContent-->

      <!--Footer-->
      <div class="white-skin">
        <copyrights class="pl-0" />
      </div>
      <!--/Footer-->

    </div>

  </div>
</template>

<script>
const RoomNav = () => import('@/components/core/RoomNav')
const Copyrights = () => import('@/components/core/Footer')

export default {
  name: 'TopNav',

  components: {
    RoomNav,
    Copyrights
  },

  mounted () {
    this.activePage = this.$route.name
  },
  updated () {
    this.activePage = this.$route.name
  }
}
</script>
